<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <app-base-main parentTable>
    <template #filter-group>
      <app-filter-group @query="$gjNoticeQuery" @reset="$gjReset">
        <gj-country-server-select v-model="filter.countryMarketValue" :width="['140px', '170px']" :showMarket="false">
        </gj-country-server-select>
        <gj-select v-model="filter.star" :options="[
          { id: 1, text: '一星' },
          { id: 2, text: '二星' },
          { id: 3, text: '三星' },
          { id: 4, text: '四星' },
          { id: 5, text: '五星' },
        ]" placeholder="全部星级" type="multi-check" width="120px"></gj-select>
        <app-filter-item priority="1">
          <gj-select v-model="filter.keyWords" :options="keyWordOptions" type="multi-check" :width="'130px'"
            placeholder="用户标识">
          </gj-select>
        </app-filter-item>
        <app-filter-item priority="1">
          <gj-select v-model="filter.statusList" :options="reviewStatusOption" type="multi-check" :width="'130px'"
            placeholder="全部状态">
          </gj-select>
        </app-filter-item>
        <gj-select v-model="filter.matchResult" :options="matchResultOptions" placeholder="匹配结果">
        </gj-select>
        <gj-select v-model="filter.lastResult" :options="trackingResultsOption" placeholder="跟踪结果">
        </gj-select>
        <gj-select-input v-model="filter.keyword" :options="reviewDynamicKeyOption" :width="['100px', '140px']">
        </gj-select-input>
        <gj-select-date-picker v-model="filter.date" type="daterange" :options="reviewTypeOption">
        </gj-select-date-picker>
        <gj-select v-model="filter.matchType" :options="matchTypeOption" placeholder="匹配方式">
        </gj-select>

        <template #right>
          <gj-tool-group setting :table-name="tableName" :table-columns="columns" :sort-gjtable="$refs.gjTable" help
            :download="$permission('review:export')" download-url="/crm/review/export" :download-params="globalParams">
          </gj-tool-group>
          <view-setting :ref="REF_VIEW_SETTING" save-mode="remote" :use-default="true" :module-name="moduleName"
            :config="model" :fn-generate-params="generateViewParams" @view-change="handleChangeView"
            @view-complete="handCompleteView">
          </view-setting>
        </template>
      </app-filter-group>
    </template>
    <template #table>
      <gj-table :name="tableName" adaptParent :data="tableData" :columns="columns" :size="'has-picture'"
        :pagination="pagination" ref="gjTable" :loading="loading" sortable="custom"
        :default-sort="{ prop: 'reviewDate', order: 'descending' }" @sort-change="$gjSortChange"
        @page-change="$gjNoticeQuery">
        <template v-slot:star="{ row }">
          <gj-rate disabled :value="row.star"></gj-rate>
          <gj-tooltip :text-line="1" :content="row.title">
            {{ row.title | defaultShow }}
          </gj-tooltip>
        </template>

        <template v-slot:asin="{ row }">
          <div class="flex">
            <div class="flex1">
            <gj-link :href="row.asinUrl" target="_blank">{{
                row.asin | defaultShow
            }}</gj-link>
            </div>
            <gj-copy-icon v-if="isMeaningful(row.asin)" :content="row.asin" />
          </div>
        </template>

        <template v-slot:variationAsin="{ row }">
          <div class="flex">
            <div class="flex1">
              <gj-link :href="row.variationAsinUrl" target="_blank">{{
                  row.variationAsin | defaultShow
              }}</gj-link>
            </div>
            <gj-copy-icon v-if="isMeaningful(row.variationAsin)" :content="row.variationAsin" />
          </div>
        </template>

        <template v-slot:productInfo="{ row }">
          <gj-tooltip :text-line="1" :content="row.productName">
            {{ row.productName || '-' }}
          </gj-tooltip>
          <div class="flex">
            <div class="flex1">
              <gj-tooltip :content="row.sku">
                {{ row.sku | defaultShow }}
              </gj-tooltip>
            </div>
            <gj-copy-icon :content="row.sku"></gj-copy-icon>
          </div>
        </template>

        <!-- <template v-slot:reviewCode="{ row }">
          <gj-link :href="row.reviewUrl" target="_blank">{{
              row.reviewCode | defaultShow
          }}</gj-link>
        </template> -->

        <template v-slot:content="{ $rowIndex, row }">
          <div class="flex">
            <gj-link :href="row.reviewUrl" target="_blank">
              <gj-tooltip :text-line="2" :content="row.content" :style="{width: 270 - (row.images.length * 60) + 'px', minWidth: '100px'}">
                {{ row.content | defaultShow }}
              </gj-tooltip>
            </gj-link>
            <template v-if="row.images && row.images.length">
              <span v-for="(item, index) in row.images.slice(0, 2)" :key="index">
                <gj-video v-if="item.videoUrl" :video-slate-img-url="item.videoSlateImgUrl" :video-url="item.videoUrl"
                  style="margin-left: 10px;">
                </gj-video>
                <gj-image v-else :src="item.videoSlateImgUrl" style="margin-left: 10px;"></gj-image>
              </span>
              <gj-popover v-if="row.images.length > 2" :value="row.taskProgressVisible" :key="row.taskProgressVisible"
                trigger="hover" placement="top" @close="taskHandler($rowIndex, false)">
                <template slot="reference">
                  <gj-button type="text" style="padding: 8px 8px;" @click="taskHandler($rowIndex, true)">
                    等共{{ row.images.length }}个
                  </gj-button>
                </template>
                <slot name="task-content">
                  <span v-for="(item, index) in row.images" :key="index">
                    <gj-video v-if="item.videoUrl" :video-slate-img-url="item.videoSlateImgUrl" :video-url="item.videoUrl"
                      style="margin-left: 10px;">
                    </gj-video>
                    <gj-image v-else :src="item.videoSlateImgUrl" style="margin-left: 10px;"></gj-image>
                  </span>
                </slot>
              </gj-popover>
            </template>
          </div>
        </template>
        <template v-slot:orderIds="{ row }">
          <template v-if="row.orderIdList && row.orderIdList.length > 0">
            <gj-tooltip>
              <div>
                <gj-link @click="openOrderDetail(row)">{{
                    row.orderIdList[0]
                }}</gj-link>
                <gj-icon v-if="row.orderIdList.length > 1" class="el-icon-arrow-down" style="margin-left: 4px;">
                </gj-icon>
                <gj-copy-icon v-if="isMeaningful(row.orderIdList[0])" :content="row.orderIdList[0]" />
              </div>
              <template #content>
                <div v-for="orderId in row.orderIdList" :key="orderId">
                  {{ orderId }}
                </div>
              </template>
            </gj-tooltip>
          </template>
          <template v-else>-</template>
        </template>

        <template v-slot:amazonUserName="{ row }">
          <div><gj-link :href="row.userUrl" target="_blank">{{
              row.amazonUserName | defaultShow
          }}</gj-link></div>
          <gj-tag style="height: 18px;line-height:18px" v-if="row.isER" :color="tagColors.lightGrayDark" type="dark">ER</gj-tag>
          <gj-tag style="height: 18px;line-height:18px" v-if="row.isHOF" :color="tagColors.lightGrayDark" type="dark">HOF</gj-tag>
          <gj-tag style="height: 18px;line-height:18px" v-if="row.isTOPC" :color="tagColors.lightGrayDark" type="dark">TOPC</gj-tag>
          <gj-tag style="height: 18px;line-height:18px" v-if="row.isTOPR" :color="tagColors.lightGrayDark" type="dark">TOPR</gj-tag>
          <gj-tag style="height: 18px;line-height:18px" v-if="row.isVINE" :color="tagColors.lightGrayDark" type="dark">VINE</gj-tag>
          <gj-tag style="height: 18px;line-height:18px" v-if="row.verified" :color="tagColors.lightGrayDark" type="dark">VP</gj-tag>
        </template>

        <template v-slot:tags="{ row }">
          <div style="display:flex">
            <gj-tooltip :text-line="1" effect="light" popperClass="lightTip">
              <template #content>
                <div class="contenBox">
                  <div class="paddBox">
                    <span v-for="(item, index) in row.tags" :key="index" class="tagSpan">
                      <gj-tag :color="tagColors.orange" type="plain" class="contentLongTag">{{ item.name }}</gj-tag>
                    </span>
                  </div>
                </div>
              </template>
              <span v-for="(item, index) in row.tags" :key="index" class="tagSpan">
                <gj-tag :color="tagColors.orange" type="plain" class="tooLongTag">{{
                    item.name
                }}</gj-tag>
              </span>
            </gj-tooltip>
            <div v-if="$permission('review:marking')" class="editIcon"
              :class="{ 'gj-cell-display-switch': tableCellEdit }" @click="editTags(row)">
              <i class="el-icon-edit"></i>
            </div>
          </div>
        </template>

        <!--状态-->
        <template v-slot:status="{ row }">
          <!--            <template v-if="$permission('review:edit')">-->
          <!--              <gj-select-->
          <!--                v-model="row.status"-->
          <!--                :clearable="false"-->
          <!--                @input="editStatus(row.id, row.status)"-->
          <!--                :options="reviewStatusOption"-->
          <!--              >-->
          <!--              </gj-select>-->
          <!--            </template>-->
          <!--            <template v-else>-->
          {{ row.status | optionText(reviewStatusOption) }}
          <!--            </template>-->
        </template>

        <!--跟踪结果-->
        <template v-slot:lastResult="{ row }">
          <gj-select v-if="row.lastResultEdit" v-model="row.lastResult" :clearable="false"
            @input="editResults(row.id, row.lastResult)" :options="trackingResultsOption" :width="'140px'">
          </gj-select>
          <span v-else max-width="90%">{{ getLastResult(row.lastResult) }}</span>
          <div v-if="!row.lastResultEdit" class="editIcon"
            :class="{ 'gj-cell-display-switch': tableCellEdit || !row.lastResultEdit }" @click="row.lastResultEdit = true">
            <i class="el-icon-edit"></i>
          </div>
        </template>

        <!-- 最终星级 -->
        <template v-slot:lastStar="{ row }">
          <gj-rate disabled :value="row.lastStar"></gj-rate>
        </template>
        <template v-slot:op="{ row }">
          <gj-button-group type="dropdown-op">
            <gj-button type="text" @click="openDetail(row.id)">匹配订单</gj-button>
            <span v-if="row.matchCount" class="num_text">{{ row.matchCount }}</span>
            <gj-button type="text" @click="openLog(row.id)">日志</gj-button>
          </gj-button-group>
        </template>
      </gj-table>
    </template>
  </app-base-main>
</template>

<script>
import {
  reviewStarOption,
  stateOption,
  reviewTypeOption,
  reviewDynamicKeyOption,
  trackingResultsOption
} from "@/utils/options";
import {
  isMeaningfulMixin,
  queryMixin,
  responseMixin,
} from "../../../../minxins";
import { isMeaningful } from "@/utils/common";
import AppReviewDetail from "@/views/components/review-modal/review-detail-modal";
import EditTagsModal from "./modal/edit-tags-modal";
import {
  // editReviewStatus,//修改状态
  exportReview,//导出？
  getReviewPage,//获取列表
  updateTrackingResul,//修改跟踪结果
} from "@/api/sale";
import { convertToDate } from "@/utils/date.util";
import { mapGetters } from "vuex";
import SaleOrderDetail from "../saleOrder/modal/sale-order-detail";
import { subDays } from "date-fns";
import model from "./viewConfig";
import { generateViewParams } from "@/utils/date.util";
import { tagColors } from "@/components/tag/tag-colors"
export default {
  name: "app-review",
  mixins: [isMeaningfulMixin, queryMixin, responseMixin],
  computed: {
    ...mapGetters({
      marketOption: "marketOption",
    }),
  },
  created() {
    this.sort.prop = "reviewDate";
    this.filter.timeStamp = null;
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        //若是从消息中心跳转
        if (sessionStorage.getItem('commentId')) {
          this.isInitParams = false;
          this.isAttemptCache = false;
          this.filter = {
            countryMarketValue: null,
            star: null,
            status: null,
            keyword: { key: "asinList", value: null, popover: false },
            date: {
              key: "reviewDate",
              value: null,
            },
          }
          this.$gjNoticeQuery();
        }
      },
    },
  },
  activated() {
    // 再次进入已被缓存的此页时,若不是从消息中心跳转
    // 若路由中查询参数timeStamp变化时，则为从其他页面点击跳转至此，重新初始化查询参数
    if (!sessionStorage.getItem('commentId')) {
      if (this.$route.query.timeStamp !== this.filter.timeStamp) {
        this.$gjQueryInit()
        this.$gjNoticeQuery()
      }
    }
  },
  data() {
    return {
      tagColors,
      tableName: "review",
      columns: [
        {
          id: "imageUrl",
          header: "图片",
          field: "picture:imageUrl",
          minWidth: "50px",
          fixed: "left",
          default: true,
          disabled: true,
        },
        {
          id: "asin",
          header: "ASIN",
          field: "slot:asin",
          minWidth: "130px",
          default: true,
          fixed: "left",
          disabled: true,
        },
        {
          id: "variationAsin",
          header: "父ASIN",
          field: "slot:variationAsin",
          minWidth: "130px",
          default: true,
        },
        {
          id: "productInfo",
          header: "产品名称/SKU",
          field: "slot:productInfo",
          minWidth: "180px",
          default: true,
        },
        {
          id: "marketId",
          header: "国家",
          field: "countryCode",
          minWidth: "50px",
          options: () => this.marketOption,
          default: true,
        },
        {
          id: "star",
          header: "星级",
          field: "slot:star",
          minWidth: "140px",
          default: true,
          sortable: true,
        },
        {
          id: "reviewCode",
          header: "评论编号",
          field: "reviewCode",
          minWidth: "145px",
          default: true,
        },
        {
          id: "helpfulNum",
          header: "点赞数",
          field: "helpfulNum",
          minWidth: "80px",
          default: true,
          sortable: true,
        },
        {
          id: "content",
          header: "留评内容",
          field: "slot:content",
          minWidth: "290px",
          default: true,
        },
        {
          id: "amazonUserName",
          header: "留评用户",
          field: "slot:amazonUserName",
          minWidth: "160px",
          default: true,
        },
        {
          id: "reviewDate",
          header: "评论日期",
          field: "reviewDate",
          minWidth: "120px",
          default: true,
          sortable: true,
        },
        {
          id: "orderIds",
          header: "订单编号",
          field: "slot:orderIds",
          minWidth: "200px",
          default: true,
        },
        {
          id: "status",
          header: "状态",
          field: "slot:status",
          width: "80px",
          default: true,
        },

        {
          id: "lastResult",
          header: "跟踪结果",
          field: "slot:lastResult",
          minWidth: "160px",
          default: true,
        },
        {
          id: "lastStar",
          header: "最终星级",
          field: "slot:lastStar",
          minWidth: "140px",
          default: true,
          sortable: true,
        },
        {
          id: "tags",
          header: "标签",
          field: "slot:tags",
          minWidth: "120px",
          default: true,
        },
        {
          id: "createTime",
          header: "记录时间",
          field: "createTime",
          minWidth: "155px",
          default: false,
          sortable: true,
        },
        {
          id: "updateTime",
          header: "更新时间",
          field: "updateTime",
          minWidth: "155px",
          default: false,
          sortable: true,
        },
        {
          id: "op",
          header: "操作",
          field: "slot:op",
          minWidth: "150px",
          fixed: "right",
          notCustomColumn: true,
        },
      ],
      tableData: [],
      filter: {
        timeStamp: null,
        countryMarketValue: null,
        star: null,
        statusList: [],// 状态
        lastResult: '',// 跟踪结果
        matchType: '',// 匹配方式
        keyWords: [],
        keyword: {
          key: "asinList",
          value: null,
          popover: false
        },
        date: {
          key: "reviewDate",
          value: [subDays(new Date(), 14), new Date()],
        },
        matchResult: null
      },
      reviewStarOption,
      reviewStatusOption: [
        { id: 'Nothing', text: '无状态' },
        { id: 'Pending', text: '待处理' },
        { id: 'Processing', text: '处理中' },
        { id: 'Done', text: '已完成' },
      ],
      matchResultOptions: [{ id: 1, text: '正确' }, { id: 0, text: '错误' }],
      /**
        TOPR:isTOPR
        TOPC:isTOPC
        ER:isER
        HOF:isHOF
        VINE:isVINE
        VP:verified （就这个是Boolean类型，其他都是int）
      */
      keyWordOptions: [
        { id: 'isTOPR', text: 'TOPR' },
        { id: 'isTOPC', text: 'TOPC' },
        { id: 'isER', text: 'ER' },
        { id: 'isHOF', text: 'HOF' },
        { id: 'isVINE', text: 'VINE' },
        { id: 'verified', text: 'VP' },
      ],
      trackingResultsOption,
      stateOption,
      reviewTypeOption,
      matchTypeOption: [
        { id: 'exact', text: '精准匹配' },
        { id: 'fuzzy', text: '模糊匹配' },
        { id: 'manual', text: '手动匹配' }
      ],
      reviewDynamicKeyOption,
      modalVisible: {
        logModal: false,
        detailModal: false,
        clickDownload: false,
      },
      moduleName: "REVIEW",
      model,
      tableCellEdit: true,
      cacheOptions: {
        useCache: true,
      }
    };
  },
  methods: {
    taskHandler(index, value) {
      this.tableData.forEach((res, j) => {
        res.taskProgressVisible = !value;
        if (j == index) {
          res.taskProgressVisible = value;
        }
      })
    },
    getLastResult(val) {
      if (val) {
        return this.trackingResultsOption.find(r => r.id === val).text
      } else {
        return '-'
      }
    },
    $gjQueryInitParams() {
      return {
        filter: {
          timeStamp: this.$route.query.timeStamp,
          countryMarketValue: this.$route.query.timeStamp && this.$route.query.timeStamp !== this.filter.timeStamp ? {
            countryIds:  this.$route.query.countryIds ? this.$route.query.countryIds.split(',') : [],
            marketIds: []
          } : {},
          star: null,
          statusList: [],// 状态
          lastResult: null,// 跟踪结果
          matchType: null,// 匹配方式
          matchResult: null,
          keyword: {
            key: this.$route.query.timeStamp && this.$route.query.timeStamp !== this.filter.timeStamp ? this.$route.query.routeKey : 'asinList',
            value: this.$route.query.timeStamp && this.$route.query.timeStamp !== this.filter.timeStamp ? this.$route.query.routeValue : null,
            popover: false
          },
          date: {
            key: "reviewDate",
            value: this.$route.query.timeStamp && this.$route.query.timeStamp !== this.filter.timeStamp ? this.$route.query.date : [subDays(new Date(), 14), new Date()],
          },
        },
      };
    },
    /**
     *
     * @param params 查询条件参数
     * @override queryMixin
     * @returns {{countryMarketValue: *}}
     */
    $gjCacheCallback(params) {
      return {
        countryMarketValue: params.countryMarketValue,
      };
    },
    $gjQuery() {
      this.loading = true;
      // 构造查询参数
      const params = {
        model: {
          stars: this.filter.star,
          statusList: this.filter.statusList,
          lastResult: this.filter.lastResult,// 跟踪结果
          matchType: this.filter.matchType,// 匹配方式
          matchResult: this.filter.matchResult
        },
        ...this.queryPagination,
        ...this.querySort,
      };
      //用户标识
      if (this.filter.keyWords && this.filter.keyWords.length > 0) {
        this.filter.keyWords.forEach(res => {
          params.model = Object.assign({ [res]: res == 'verified' ? true : 1 }, params.model)
        })
      }
      // 如果是从消息中心过来的，那么记得清除调storage
      if (sessionStorage.getItem('commentId')) {
        this.isAttemptCache = true;
        params.model.reviewId = sessionStorage.getItem('commentId');
        sessionStorage.removeItem('commentId');
      }
      // 关键词查询
      params.model[this.filter.keyword.key] = this.filter.keyword.key === 'asinList' ? (this.filter.keyword.value ? this.filter.keyword.value.split(',') : []) : this.filter.keyword.value;
      // 店铺国家
      if (this.filter.countryMarketValue) {
        params.model.countryCodes = this.filter.countryMarketValue.countryIds;
      }
      // 时间
      if (isMeaningful(this.filter.date.value)) {
        if (this.filter.date.key === "reviewDate") {
          params.model.reviewStartDate = convertToDate(
            this.filter.date.value[0]
          );
          params.model.reviewEndDate = convertToDate(this.filter.date.value[1]);
        } else if (this.filter.date.key === "updateTime") {
          params.model.updateStartTime = convertToDate(
            this.filter.date.value[0]
          );
          params.model.updateEndTime = convertToDate(this.filter.date.value[1]);
        } else if (this.filter.date.key === "createTime") {
          params.model.createStartTime = convertToDate(
            this.filter.date.value[0]
          );
          params.model.createEndTime = convertToDate(this.filter.date.value[1]);
        }
      }
      this.globalParams = params;
      // 查询
      getReviewPage(params)
        .then((data) => {
          if (isMeaningful(data)) {
            data.records.forEach(item => {
              item.lastResultEdit = false;
              item.images = [];
              item.taskProgressVisible = false;
            })
            this.tableData = data.records;
            this.tableData.forEach(res => {
              if (res.media && res.media.reviewImageUrls.length) {
                res.media.reviewImageUrls.forEach(img => {
                  res.images.push({
                    videoSlateImgUrl: img,
                    videoUrl: ''
                  })
                })
              }
              if (res.media && res.media.videos.length) {
                res.images = res.images.concat(res.media.videos)
              }
            })
            this.pagination = this.getPagination(data);
          }
        })
        .complete(() => {
          this.loading = false;
        });
    },
    /**
             * <!--                                <app-order-detail-->
             <!--                                        :modal-mount-to="$el"-->
             <!--                                        :order-id="orderId"-->
             <!--                                        :market-id="row.marketId"-->
             <!--                                ></app-order-detail>-->
             * @param row
             */
    openOrderDetail(row) {
      this.$gjCreate(SaleOrderDetail, {
        props: {
          orderId: row.orderIdList[0],
          marketId: row.marketId,
        },
      });
    },
    openDetail(id) {
      let changeFlag = false;
      this.$gjCreate(AppReviewDetail, {
        props: {
          id: id,
        },
        on: {
          changeData() {
            changeFlag = true;
          },
          close: () => {
            if (changeFlag) {
              this.$gjQuery();
            }
          }
        },
      });
    },
    openLog(id) {
      this.$gjCreate("gj-log-modal", {
        props: {
          url: "/crm/review/" + id + "/logs",
        },
      });
    },
    editTags(row) {
      this.$gjCreate(EditTagsModal, {
        props: {
          tag: row,
        },
        on: {
          created: () => {
            this.$gjQuery();
          },
        },
      });
    },
    clickDownload() {
      exportReview(this.globalParams);
    },

    search() { },
    editResults(id, lastResult) {
      updateTrackingResul(id, lastResult).then(res => {
        this.$gjResponseHandle(res, () => {
          this.$gjMessage.success("更新成功");
          this.$gjResetPage();
        });
      })
    },
    // editStatus(id, status) {
    //   editReviewStatus(id, status).then((res) => {
    //     this.$gjResponseHandle(res, () => {
    //       this.$gjMessage.success("更新成功");
    //       this.$gjResetPage();
    //     });
    //   });
    // },
    generateViewParams,
    loadViewComplete() {
      this.$emit("query");
    },
  },
};
</script>

<style scoped>
.contentLongTag {
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tooLongTag {
  max-width: 50px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tagSpan {
  display: inline-block;
  margin-bottom: 3px;
}

.editIcon {
  cursor: pointer;
  margin-left: 5px;
}

.contenBox {
  max-width: 640px;
  max-height: 120px;
  overflow-y: auto;
}

.paddBox {
  padding: 10px 10px 3px;
}

.num_text {
  font-size: 12px;
  color: #FFFFFF;
  border-radius: 6px;
  background: #1F6EEF;
  text-align: center;
  padding: 1px 5px;
  vertical-align: text-top;
  margin-left: 4px !important;

}
</style>
